import { jsx as _jsx } from "react/jsx-runtime";
import UILink from 'UIComponents/link/UILink';
import { LogoBody } from './LogoBody';
export const HeaderLogo = ({
  altText,
  showMobileView,
  imageSrc,
  onClick,
  shouldLogoBeClickable,
  width,
  height
}) => {
  if (onClick) {
    if (!shouldLogoBeClickable) {
      return /*#__PURE__*/_jsx("div", {
        onClick: onClick,
        children: /*#__PURE__*/_jsx(LogoBody, {
          altText: altText,
          height: height,
          imageSrc: imageSrc,
          showMobileView: showMobileView,
          width: width
        })
      });
    }

    return /*#__PURE__*/_jsx(UILink, {
      onClick: onClick,
      children: /*#__PURE__*/_jsx(LogoBody, {
        altText: altText,
        height: height,
        imageSrc: imageSrc,
        showMobileView: showMobileView,
        width: width
      })
    });
  }

  return /*#__PURE__*/_jsx(LogoBody, {
    altText: altText,
    height: height,
    imageSrc: imageSrc,
    showMobileView: showMobileView,
    width: width
  });
};